import { randomIntFromInterval } from '../number/';

export const FlashcardTypes = [
  'a', // anki-style, e.g. {{c1::thing 1}}
  'aa', // anki-style hide ALL answers (?)
  'u', // underline, hide one answer, e.g. this is a <u>underlined</u> answer
  'ua', // underline, hide ALL answers
  'r', // replaces the front with the back (images types only?)
  //'img' // img occlusion
] as const;

export type FlashcardType = (typeof FlashcardTypes)[number];

export const underlineRegexFlashcard = /<u>([\w\W]+?)<\/u>/g;

export const clozeRegexFlashcard = /\{\{([\w\W::(\w\W)]+?)\}\}/g;

export const parseUnderlineFlashcard = (text = '') =>
  text.replace(/<u>/g, '').replace(/<\/u>/g, '');

export const parseClozeFlashcard = (text = '') => {
  return text.replace(
    clozeRegexFlashcard,
    (v, p1: string) => p1.split('::')[1],
  );
};

export const replaceOneFlashcard = (
  text: string,
  regex: RegExp,
  index = -1,
  blank = '',
): string => {
  const matches = text.match(regex);
  if (matches && index > -1) {
    return text.replace(matches[index], blank);
  }

  return text;
};

export const getRandomIndexFlashcard = (
  text: string,
  type?: FlashcardType,
): number | undefined => {
  let matches;
  if (type === 'u') {
    matches = text.match(underlineRegexFlashcard);
  } else if (type === 'a') {
    matches = text.match(clozeRegexFlashcard);
  }

  if (matches) {
    const index = randomIntFromInterval(0, matches.length - 1);

    return index ?? -1;
  }

  return undefined;
};
